import { Component, input, output, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Menu } from 'primeng/menu';
import { ActionDto, InitState, KlGridExportScope } from '../../grid.models';

@Component({
  selector: 'kl-grid-toolbar',
  standalone: false,
  templateUrl: './kl-grid-toolbar.html',
  styleUrl: './kl-grid-toolbar.scss',
})
export class KlGridToolbar {
  readonly showButton = input(true);
  readonly bulkDeleteEnabled = input(false);
  readonly doRefresh = input(true);
  readonly doAdd = input(true);
  readonly doDelete = input(true);
  readonly doEdit = input(true);
  readonly doView = input(true);
  readonly filterable = input(false);
  readonly customFilter = input(false);
  readonly doExport = input(true);
  readonly disabledButton = input(false);
  readonly recordFetchLoading = input(false);
  readonly initStatesWithoutChild = input<InitState[]>([]);
  readonly initStatesWithChild = input<InitState[]>([]);
  readonly addInitStatesMenuModel = input<MenuItem[]>([]);
  readonly editViewMenuModel = input<MenuItem[]>([]);
  readonly filterMenuModel = input<MenuItem[]>([]);
  readonly exportMenuModel = input<MenuItem[]>([]);
  readonly processesMenuModel = input<MenuItem[]>([]);
  readonly otherMenuModel = input<MenuItem[]>([]);
  readonly customToolbar = input<ActionDto[]>([]);
  readonly customToolbarVisible = input(true);
  readonly showProcessesMenu = input(false);
  readonly hasOtherMenu = input(false);
  readonly fullscreenEnabled = input(false);
  readonly fullscreenActive = input(false);
  readonly menuAppendTo = input<unknown>('body');

  readonly refreshClick = output<void>();
  readonly openNewClick = output<InitState | undefined>();
  readonly deleteClick = output<void>();
  readonly editClick = output<void>();
  readonly viewClick = output<void>();
  readonly toggleFilterClick = output<void>();
  readonly exportClick = output<KlGridExportScope>();
  readonly customToolbarActionClick = output<ActionDto>();
  readonly confirmBulkDeleteClick = output<void>();
  readonly cancelBulkDeleteClick = output<void>();
  readonly toggleFullscreenClick = output<void>();

  @ViewChild('addInitStatesMenu') addInitStatesMenu?: Menu;
  @ViewChild('editViewMenu') editViewMenu?: Menu;
  @ViewChild('filterMenu') filterMenu?: Menu;
  @ViewChild('exportMenu') exportMenu?: Menu;
  @ViewChild('processesMenu') processesMenu?: Menu;
  @ViewChild('otherMenu') otherMenu?: Menu;
}
